import {Entity, Cartesian3, PropertyBag} from 'cesium';
import {Label as getLabelStyle, Point as getStyle, setEntityStyle} from '../renderer';

export default class Point extends Entity {
    constructor(options) {
        const {geometry, properties, style, label, ...other} = options;

        let props = {
            clampToGround: true,
            position: Cartesian3.fromDegrees(...geometry),
            properties: new PropertyBag(properties),
            point: {
                ...getStyle({...style}),
            },
            ...other,
        };

        // 添加label
        if (label?.text) {
            props.label = getLabelStyle(label);
        }

        super(props);

        this.geometry = geometry;
    }

    setGeometry(geometry) {
        this.position.setValue(Cartesian3.fromDegrees(...geometry));
    }

    setProperties(properties) {
        this.properties.setValue(new PropertyBag(properties));
    }


    setLabel(label) {
        this.label.setValue(getLabelStyle(label))
    }

    setStyle(style) {
        setEntityStyle(this.point, getStyle({...style}));
    }
}
